import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpHandler,
} from '@angular/common/http';
import { LoginService } from '../app/modules/core/services/login.service';

export const environment = {
  production: false,
  BaseAPI: 'https://api.chessx.ai/api/v1/',
  socketUrl: 'https://api.chessx.ai/',
  secretKey :'chessxwithoutai'
};

export const googleConfig = {
  exchangeCodeForIdToken(
    code: string,
    http: HttpClient,
    loginserv: LoginService
  ): void {
    const tokenEndpoint = 'https://oauth2.googleapis.com/token';

    const body = new HttpParams()
      .set('code', code)
      .set(
        'client_id',
        '764763259397-ageb1qhnkcfa9hbks3qt29639pvp1rfk.apps.googleusercontent.com'
      )
      .set('client_secret', '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')

      .set('redirect_uri', 'https://chessx.ai/login')
      .set('grant_type', 'authorization_code');

    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/x-www-form-urlencoded'
    );

    http.post<any>(tokenEndpoint, body.toString(), { headers }).subscribe(
      (response) => {
        const idToken = response.id_token;
        loginserv.googlePostLogin(idToken).subscribe((res) => {});
      },
      (error) => {
        console.error('Token exchange error', error);
      }
    );
  },

  googleClick() {
    const googleOAuthUrl = 'https://accounts.google.com/o/oauth2/v2/auth';

    const params = new URLSearchParams({
      client_id:
        '764763259397-ageb1qhnkcfa9hbks3qt29639pvp1rfk.apps.googleusercontent.com',
      redirect_uri: 'https://chessx.ai/login',
      response_type: 'code',
      scope: 'openid profile email',
    });

    window.location.href = `${googleOAuthUrl}?${params.toString()}`;
  },
};
